import MDSpinner from 'react-md-spinner';

type Props = {
  color?: string;
  style?: any;
  size?: number;
  duration?: number;
};

const Spinner = ({ color, style, size, duration }: Props) => {
  return (
    <MDSpinner
      duration={duration}
      size={size}
      singleColor={`${color}`}
      style={style}
    />
  );
};

export default Spinner;
